import axios from "axios";
import { ROLES, UTILS } from "../../endpointsConst";

const RolesDropdownService = {};

RolesDropdownService.getRoles = (lang) =>
    axios.get(UTILS + ROLES + `?lang=${lang}`).catch((e) => {
        return new Error(e.response.status);
    });

export { RolesDropdownService };
